import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  pinButton: {
    textAlign: 'end',
    padding: theme.spacing(1.5, 1.25),

    '& .MuiTypography-root': {
      color: theme.palette.primary.light,
      cursor: 'pointer',

      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },

  inbox: {
    height: `calc(100% - ${theme.spacing(6.75)})`,
  },
}));
